import React from 'react';
import { SkeletonLine, SkeletonCircle, Box } from '@wix/design-system';

interface NarrowSlimAppBoxSkeletonProps {
  className?: string;
}

export function SlimAppBoxSkeleton({
  className,
}: NarrowSlimAppBoxSkeletonProps) {
  return (
    <Box
      className={className}
      width="100%"
      height="100%"
      direction="vertical"
      align="space-between"
    >
      <Box direction="vertical">
        <Box gap="12px">
          <Box flexShrink={0}>
            <SkeletonCircle diameter="60px" />
          </Box>
          <Box width="100%">
            <Box direction="vertical">
              <SkeletonLine width="72px" marginTop="6px" />
              <SkeletonLine width="144px" marginTop="12px" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
